const getSession = (key, fallback) => window.sessionStorage.getItem(key) || fallback;

export default [
  {
    path: "/actualizarclave",
    name: "ActualizarClave",
    component: () => import("@/views/regLog/ActualizarClave.vue"),
    props: (route) => ({
      usuario: route.query.usuario || getSession("usuario", ""),
      idUsuario: route.query.idUsuario || getSession("idUsuario", 0),
    }),
  },
  {
    path: "/cargar-pdfs/:p_idtramite",
    name: "CargarPDFs",
    component: () => import("@/components/CargarPDFs.vue"),
  },
  {
    path: "/indexador-pdfs/:p_idtramite",
    name: "IndexadorPDFs",
    component: () => import("@/components/IndexadorPDFs.vue"),
  },
  {
    path: "/cargar-indexar-pdfs/:p_idtramite",
    name: "CargarIndexarPDFs",
    component: () => import("@/components/CargarIndexarPDFs.vue"),
  },
];